/* RedTrack click-id capture + checkout postback.
   Persists the click id from the landing URL, then:
     - properties[_rtkclickid] on every /cart/add form (survives "Buy it now" and return_to=/checkout)
     - a cart attribute
     - fires InitialOrderFormImpression on buy-form submit
   The postback runs here rather than in a Shopify Custom Pixel because the pixel
   sandbox could not reliably resolve the click id. Here it is a local variable.
   Inert when there is no click id: returns before touching the page. */
(function () {
  var COOKIE = 'rtkclickid';
  var PROP = '_rtkclickid';
  var POSTBACK = 'https://track.leadinghealthmagazine.com/postback';

  function readCookie(n) {
    var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)');
    return m ? decodeURIComponent(m[2]) : '';
  }

  var q = new URLSearchParams(location.search);
  var cid = q.get('rtkclickid') || q.get('rtkcid') || q.get('clickid')
         || readCookie(COOKIE) || readCookie('rtkcid');
  if (!cid) return;

  document.cookie = COOKIE + '=' + encodeURIComponent(cid) +
    ';path=/;max-age=2592000;SameSite=Lax';

  function tagForms() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      var el = f.querySelector('input[name="properties[' + PROP + ']"]');
      if (!el) {
        el = document.createElement('input');
        el.type = 'hidden';
        el.name = 'properties[' + PROP + ']';
        f.appendChild(el);
      }
      el.value = cid;
    }
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; tagForms(); }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tagForms);
  } else {
    tagForms();
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });

  var attrs = {}; attrs[PROP] = cid;
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: attrs })
  }).catch(function () {});

  // InitialOrderFormImpression, fired once per session as the buyer commits to checkout.
  // sendBeacon is built to survive the navigation that immediately follows the submit.
  function fired() {
    try { return sessionStorage.getItem('rtk_ic_' + cid) === '1'; } catch (e) { return false; }
  }
  function markFired() {
    try { sessionStorage.setItem('rtk_ic_' + cid, '1'); } catch (e) {}
  }
  function impression() {
    if (fired()) return;
    markFired();
    var u = POSTBACK + '?clickid=' + encodeURIComponent(cid) + '&type=InitialOrderFormImpression';
    if (navigator.sendBeacon) { navigator.sendBeacon(u); }
    else { try { new Image().src = u; } catch (e) {} }
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.tagName === 'FORM' && (f.getAttribute('action') || '').indexOf('/cart/add') !== -1) {
      impression();
    }
  }, true);
})();
